import { Academy } from '../types';
import { AcademyFormInput } from '../types/form';

export function transformAcademyToFormInput(academy: Academy): AcademyFormInput {
  return {
    name: academy.name,
    logoImagePath: academy.logoImagePath,
  };
}
